module.exports = "<app-poi-edit-accommodation poi=$ctrl.poi on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-poi-edit-accommodation> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/accommodation/template.html
// module id = 427
// module chunks = 0